var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.844V3.75a.75.75 0 1 0-1.5 0v6.094a3 3 0 0 0 0 5.812v4.594a.75.75 0 1 0 1.5 0v-4.594a3 3 0 0 0 0-5.812m-.75 4.406a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m7.5-8.906V3.75a.75.75 0 1 0-1.5 0v1.594a3 3 0 0 0 0 5.812v9.094a.75.75 0 1 0 1.5 0v-9.094a3 3 0 0 0 0-5.812M12 9.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9.75 6a3.005 3.005 0 0 0-2.25-2.906V3.75a.75.75 0 1 0-1.5 0v9.094a3 3 0 0 0 0 5.812v1.594a.75.75 0 1 0 1.5 0v-1.594a3.005 3.005 0 0 0 2.25-2.906m-3 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
  })));
};
export default SvgFilter;